import React from 'react'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress'
import {browserHistory} from 'react-router'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {

  async componentDidMount () {
    const result = await ApiRequest(project.api + 'slack', {
      requete: 'file',
      action: 'delete',
      code: this.props.location.query.code,
    }, { returnAnyway: true })
    if (result && result.code === 1) {
      browserHistory.push({
        pathname: '/'
      })
    } else {
      alert('Une erreur s\'est produite lors de la suppression de vos fichiers, veuillez réessayer plus tard....')
      browserHistory.push({
        pathname: '/'
      })
    }
  }

  render () {
    return <Grid container spacing={0} style={{ margin: 0, padding: 0 }} direction="column" justify="center"
                 alignItems="center" className="EurestoBodyConnection grad">
      <b style={{}}>Suppression de vos fichiers sur Slack, veuillez patienter...</b>
      <CircularProgress size={100} thickness={4} className={'EurestoPrimary--text'}/>
    </Grid>
  }
}



// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/SlackDeleteFile/index.js